import * as React from 'react';

import { VALID_DIMENSION_DATA } from '../Utils';

import { StyledTableTh } from './TableStyles';

export interface ITableThProps extends React.ThHTMLAttributes<HTMLTableDataCellElement> {
  order?: string;
  textAlign?: string;
  width?: VALID_DIMENSION_DATA;
}

export const TableTh: React.FC<ITableThProps> = ({
  children,
  order,
  textAlign,
  width,
  ...rest
}) => (
  <StyledTableTh
    {...rest}
    orderProp={order}
    textAlign={textAlign}
    widthProp={width}
  >
    {children}
  </StyledTableTh>
);
